import React from "react";
import { Typography, Divider, List, ListItemText } from "@mui/material";
import { styled } from "@mui/system";
import Header from "../components/Header";
import {
  primaryBg,
  primaryTxt,
  secondaryBg,
  secondaryTxt,
} from "../constants/colors";

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100vw",
  minHeight: "100vh",
  backgroundColor: primaryBg,
});

const SectionTitle = styled(Typography)({
  marginTop: "20px",
  fontWeight: "bold",
  color: primaryTxt,
});

const ListItemTextStyled = styled(ListItemText)(({ isImportant = false }) => ({
  marginBottom: "4px",
  paddingTop: "0px",
  color: secondaryTxt,
  fontWeight: isImportant ? "bold" : "normal", // Apply bold if the item is important
  textTransform: isImportant ? "uppercase" : "none", // Apply uppercase if the item is important
  backgroundColor: isImportant ? secondaryBg : "default",
  marginRight: "20px",
}));

const ListStyled = styled(List)({
  padding: "0", // Remove padding from the List component
  margin: "0", // Remove margin from the List component
  marginTop: "-14px",
});

// Helper function to render section with title and content
const RenderSection = ({ title, content, important = false }) => (
  <>
    <SectionTitle variant="h6">{title}</SectionTitle>
    <ListStyled>
      •{" "}
      {content.map((item, index) => {
        console.log("important: ", important, " index: ", index);
        return (
          <ListItemTextStyled key={index} isImportant={index === important}>
            • {item}
          </ListItemTextStyled>
        );
      })}
    </ListStyled>
    <Divider />
  </>
);

const HouseInstructions = () => {
  // Section content data
  const sections = [
    {
      title: "Key Access",
      content: [
        "Lockbox location: Wall to the right of the red door by the parking.",
        "Lockbox code: Sent upon booking confirmation.",
        "Important: Return the key to the lockbox when you leave. The key works for all locks.",
      ],
      important: 2,
    },
    {
      title: "Check-In & Check-Out",
      content: [
        "Check-in: After 3 PM.",
        "Check-out: By 10 AM. Please contact us in advance if you need extra time.",
        "Pets: Dogs are welcome, but please keep them off the beds and furniture.",
      ],
    },
    {
      title: "WiFi",
      content: ["Network: 37 Johnson Way", "Password: Tazz@147"],
    },
    {
      title: "Quiet Hours",
      content: [
        "10 PM - 7 AM. Please keep noise to a minimum during these hours.",
      ],
    },
    {
      title: "Bear Warning",
      content: [
        "Bears are present in the area. Keep all doors closed when away and at night to prevent them from entering the house. Do not leave food or garbage outside.",
      ],
      important: 0,
    },
    {
      title: "Check-Out Procedures",
      content: [
        "Place used sheets in the washing machine.",
        "Wash all dishes before leaving.",
        "Return the key to the lockbox.",
      ],
    },
    {
      title: "Emergency Information",
      content: [
        "Emergency Assistance: Call 911.",
        "Electric Circuit Breaker: Outside the mudroom door, on the left.",
      ],
    },
    {
      title: "Cookware & Pantry",
      content: [
        "Cookware is stored in cabinets. Help yourself to teas, spices, and pantry items (honor system—please leave something if you take something).",
      ],
    },
    {
      title: "Garbage",
      content: [
        "Bear Safety: Do not leave food or garbage outside or in your car.",
        "Trash: Place in the trash compactor to the right of the dishwasher.",
        "Recyclables: Place cans, glass, and plastic in the pull-out cabinet container next to the trash compactor.",
        "Paper: Place newspapers in the copper bin to the left of the wood stove.",
        "Contact for Full Trash Compactor: Call Laura at (530) 862-5018.",
      ],
      important: 0,
    },

    {
      title: "Wood Stove",
      content: [
        "Wood: Stored in the woodshed.",
        "Lighter: In the top drawer to the right of the sink.",
        "Kindling: In the bin on the right side of the stove.",
      ],
    },
    {
      title: "BBQ",
      content: [
        "Move the grill 1-2 feet away from the house before use.",
        "To start: Open propane tank, wait 60 seconds, then ignite.",
        "Clean the grill after use, including the drip pan ($20 fee if left dirty)",
        "Propane: Provided; turn off after use to prevent leaks.",
      ],
      important: 2,
    },
    {
      title: "Washer & Dryer",
      content: [
        "Located in the hallway. Detergent is in the closet across from the washer and dryer.",
      ],
    },
    {
      title: "Cleaning Supplies",
      content: [
        "Rags and towels for cleaning pets or spills are in the entry room closet.",
      ],
    },
    {
      title: "Heating",
      content: [
        "Baseboard heaters in bedrooms. The wood stove can heat the entire house.",
      ],
    },
    {
      title: "Lights",
      content: ["Dimmers installed; extra bulbs in the front entrance closet."],
    },
    {
      title: "Septic System",
      content: [
        "Use the garbage disposal sparingly; we are on a septic system. Do not flush feminine products down the toilet.",
      ],
      important: 0,
    },
    {
      title: "Extra Sheets & Blankets",
      content: [
        "Stored in the storage bin on the top shelf of the far back bedroom closet.",
      ],
    },
    {
      title: "Bike Shoes",
      content: ["Please do not wear bike shoes inside the house."],
    },
    {
      title: "PLEASE PLEASE PLEASE",
      content: [
        "do not leave any food outside or in your car.....LOCK your car at night, they will open your car door and if trapped can destroy the inside of your car. The bears will eat any food left out and then the bear will have to be killed if it becomes a nuisance.",
      ],
      important: 0,
    },
    {
      title: "Final Checklist",
      content: [
        "Did you leave the key in the lockbox?",
        "Are the baseboard heaters turned off?",
        "Please check around for your belongings.",
        "Thank you. Have a safe and enlightening journey.",
      ],
    },
  ];

  return (
    <Container>
      <Header />
      <div
        style={{ marginLeft: "40px", marginTop: "50px", marginBottom: "50px" }}
      >
        <SectionTitle variant="h4">House Instructions</SectionTitle>
        {sections.map((section, index) => (
          <RenderSection
            key={index}
            title={section.title}
            content={section.content}
            important={section.important}
          />
        ))}
        <SectionTitle variant="h6">
          {`If something is not working or if you have ANY PROBLEM please contact
          us (415-246-4212)`}
        </SectionTitle>
        <span style={{ marginBottom: "50px" }} />
      </div>
    </Container>
  );
};

export default HouseInstructions;
